import 'images';
import 'styles';
import 'utils/font_loader';
import 'utils/turbolinks';
/* Utils */
import 'utils/general';
import 'utils/permissions/limits';
import 'utils/permissions/permissions';
import 'utils/prototype';
import 'utils/storage';
// import 'utils/input_mask';
import 'utils/blazy';
import 'utils/bootstrap';
import 'utils/bs_dropdown';
import 'utils/current_user'; // TODO: Refact - Import in each module and remove from application.js
import 'utils/event_manager';
import 'utils/form_clear';
import 'utils/icontains';
import 'utils/lazy';
import 'utils/media_query';
import 'utils/scroll_to';
import 'utils/statements';
import 'utils/thor';
import 'utils/toastr';
import 'utils/toggle_input';
import 'utils/turbolinks_form';
import 'utils/vendor_manager';
/* Global Components */
import 'components/ajax_sidebar';
import 'components/billing/billing_top_bar';
import 'components/breadcrumb';
import 'components/campaigns/interventions/top_bar';
import 'components/cookies_agreement';
import 'components/dev_loading';
import 'components/footer';
import 'components/google_one_tap_auth';
import 'components/header';
import 'components/intervention_bottom_bar';
import 'components/lesson_freemium/alert';
import 'components/lesson_freemium/banner';
import 'components/lesson_freemium/sign_in';
import 'components/logo';
import 'components/menu';
import 'components/menu_old';
import 'components/modals/elite_trial_modal';
import 'components/modals/not_premium_user_modal';
import 'components/modals/pay_wall_modal';
import 'components/modals/paywall_early_modal';
import 'components/modals/question_answer';
import 'components/modals/setup';
import 'components/modals/study_goal_modal';
import 'components/modals/elite_trial_modal';
import 'components/new_menu';
// import 'components/new_menu_old'; // logged in
import 'components/notification_bar'; // logged in
import 'components/outdated_browser';
import 'components/pagination';
import 'components/payment_error_topbar'; // logged in
import 'components/share'; // logged in
import 'components/smart_banner';
import 'components/sticky_cta_menu';
import 'components/subscription_expiration_modal';
import 'components/trial/modal';
import 'components/trial/top_bar';
/* External Services */
import 'components/modals/lifelong_upgrade_modal';
import 'utils/serialize_object';
import 'utils/trackers';
import 'utils/trackers/user';
import zaraz from 'utils/trackers/zaraz';
import { initializeIntercom } from '../shared/intercom_manager';
import { loadLazyScripts } from 'utils/lazy_scripts';

if (global.RAILS_ENV === 'development') {
  const hideLoading = () => {
    const loading = document.getElementById('dev-loading');

    if (loading) {
      loading.remove();
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    hideLoading();
    document.addEventListener('turbolinks:render', () => hideLoading());
  });
}

const trackIterablePageView = () => {
  UserTracker.emit('event', {
    eventName: 'pageVisited',
    data: {
      pageName: window.location.pathname + window.location.search,
      hostname: window.location.hostname,
      pathname: window.location.pathname,
      search: window.location.search
    },
    only: ['iterable']
  });
};

const trackEventMenu = () => {
  const $container = $('#experimentMenu');
  const eventData = $container.data('event') || {};

  const isSendEvent =
    eventData?.active && eventData?.zaraz_send_event && eventData?.event_props;

  if ($container && isSendEvent) {
    zaraz.set('show_experiment', 'true', { scope: 'persist' });
    zaraz.track(eventData.zaraz_event, eventData.event_props);
  }
};

const trackTurbolinksRender = () => {
  zaraz.track('turbolinks-loaded');
};

const postMessage = params => {
  if (params.get('from_omniauth') && params.get('provider')) {
    window.postMessage({ success: true }, window.location.origin);
  }
};

requestIdleCallback(async () => {
  loadLazyScripts();

  trackIterablePageView();
  trackEventMenu();
  trackTurbolinksRender();
  postMessage(new URLSearchParams(window.location.search));

  // Initialize Intercom for main app
  initializeIntercom({
    appName: 'Main',
    enablePolling: true
  });

  document.addEventListener('turbolinks:render', () => {
    trackIterablePageView();
    trackEventMenu();
    trackTurbolinksRender();
    postMessage(new URLSearchParams(window.location.search));
  });
});
